import { render, staticRenderFns } from "./ModeloShow.vue?vue&type=template&id=b37d62f2&"
import script from "./ModeloShow.vue?vue&type=script&lang=js&"
export * from "./ModeloShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports